// extracted by mini-css-extract-plugin
export default {"wrapper":"Quiz_wrapper__358SV","loading":"Quiz_loading__BWlRc","content":"Quiz_content__YW6Y2","topLevel":"Quiz_topLevel__u3WLI","maj":"Quiz_maj__-rXbI"};